
import { AppBar, Grid, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({    //deal with that last
    AppBar: {
        top: 'auto',
        bottom: 0,
        color: theme.palette.secondary.main,
    }
}));


const Footer = () => {
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <AppBar position="fixed" className={classes.AppBar}>
            <Toolbar>
                <Grid container justify="space-around">
                    <Grid item>
                        <Typography align="center" variant="caption" display="block" >
                            <small>To request more features or provide feedback contact:</small>
                        </Typography>
                        <Typography align="center" variant="caption" display="block" >
                            <small><small>Comminity manager</small></small>
                        </Typography>
                        <Typography align="center" variant="caption" display="block">
                            <small><small>Specials credits to:<small> Grumpy & Peshosh</small></small></small>
                        </Typography>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    )
}
export default Footer;
